import { addClient, setClasseForm, setLyceeForm } from '../../store/actions';
import Store from '../../store/configureStore';
import { generateFakerClasseState } from './classe';
import { generateFakeLyceeState } from './lycee';
import { generateFakeClientState } from './client';

const initDummy = async () => {
  if (process.env.NODE_ENV !== 'production') {
    try {
      import('@faker-js/faker')
        .then(({ faker }) => generateFakerClasseState(faker))
        .then(res => Store.dispatch(setClasseForm(res)));
      import('@faker-js/faker')
        .then(({ faker }) => generateFakeLyceeState(faker))
        .then(res => Store.dispatch(setLyceeForm(res)));
      import('@faker-js/faker')
        .then(({ faker }) => generateFakeClientState(faker))
        .then(res => Store.dispatch(addClient(res)));
    } catch (e) {
      console.error(e);
    }
  }
};
export default initDummy;
